import AIJob from 'models/AIJob';

export enum SummarizationStage {
  ProcessingFiles = 'Processing files',
  IdentifyingPatientDemographics = 'Identifying patient demographics',
  GeneratingSummary = 'Generating summary',
  FinishingUp = 'Finishing up',
}

// Attribute extraction runs beside the summary, so only a patient demographics job gets a stage.
export function summarizationLoadingStages(patientDemographicsJob: AIJob | null): SummarizationStage[] {
  return Object.values(SummarizationStage).filter(
    (stage) => stage !== SummarizationStage.IdentifyingPatientDemographics || !!patientDemographicsJob
  );
}

export function summarizationLoadingStage({
  stages,
  summaryJob,
  patientDemographicsJob,
  onFinalStage,
}: {
  stages: SummarizationStage[];
  summaryJob: AIJob | null;
  patientDemographicsJob: AIJob | null;
  onFinalStage: boolean;
}): number {
  if (!summaryJob) return 0;
  if (summaryJob.isCompleted) return stages.length + 1;

  let stage: SummarizationStage;
  if (summaryJob.isAwaiting || summaryJob.isRunning) {
    stage = onFinalStage ? SummarizationStage.FinishingUp : SummarizationStage.GeneratingSummary;
  } else if (patientDemographicsJob?.isAwaiting || patientDemographicsJob?.isRunning) {
    stage = SummarizationStage.IdentifyingPatientDemographics;
  } else if (summaryJob.isPending) {
    stage = SummarizationStage.ProcessingFiles;
  } else {
    return 0;
  }

  return stages.indexOf(stage) + 1;
}
